<script setup>
import { ref } from "vue";
const props = defineProps(["resource"]);
const separator = ref('border-bottom mb-3')
</script>
<template>
  <div class="bg-light p-4 shadow-sm mt-5" aria-live="polite" v-if="props.resource?.paymentAttributes || props.resource?.preWarning || props.resource?.additionalLink">
    <h2 class="h3 mb-3">Avvertenze</h2>
    <div class="bg-white p-4 mt-4">
      <div :class="[props.resource?.preWarning || props.resource?.additionalLink ? separator :'']" v-if="props.resource?.paymentAttributes">
        <small class="fw-bold">Servizio a pagamento</small>
        <p class="mb-2">
          Il servizio selezionato prevede un contributo di
          {{ props.resource.paymentAttributes.requiredAmount || "" }}€
        </p>
      </div>

      <div :class="[props.resource?.additionalLink ? separator :'']" v-if="props.resource?.preWarning">
        <small class="fw-bold">Avvertenze in fase di prenotazione</small>
        <div class="mb-2" v-html="props.resource?.preWarning || ''"></div>
      </div>

      <div v-if="props.resource?.additionalLink">
        <small class="fw-bold">Link</small>
        <p class="mb-2">
          <a :href="props.resource?.additionalLink || '#'" target="_blank">
            {{ props.resource?.additionalLink || "" }}
          </a>
        </p>
      </div>

    </div>
  </div>
</template>
